import { FC } from 'react';
import {
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
  Route,
} from 'react-router-dom';
import List from './List';
import Create from './Create';
import PrivateRoute from '@components/App/PrivateRoute';
import Detail from './Detail';
import Idea from './Idea';

const IdeaRouter: FC = () => {
  const { path } = useRouteMatch();
  let location = useLocation();
  console.log(location);
  const history = useHistory();
  if (location.pathname === '/idea') {
    history.push('/idealist');
  }
  return (
    <div>
      <Switch>
        <Route path={`/idealist`}>
          <List />
        </Route>
        <PrivateRoute path={`/idea/create`}>
          <Create />
        </PrivateRoute>
        <PrivateRoute path={`/idea/:pollId/create`}>
          <Create />
        </PrivateRoute>
        <PrivateRoute path={`/idea/:pollId/edit`}>
          <Create edit={true} />
        </PrivateRoute>
        <Route exact path={`/idea/:pollId`}>
          <Detail />
        </Route>
        <PrivateRoute exact path={`/idea/:pollId/pledge`}>
          <Idea />
        </PrivateRoute>
      </Switch>
    </div>
  );
};

export default IdeaRouter;
